var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container"},[_vm._v("\n    © Copyright Media Tech 2025. All rights reserved. "),_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(" 沪ICP备2024102204号-1")])])
}
var staticRenderFns = []

export { render, staticRenderFns }